import React, { useContext } from 'react';

import Grid from '@material-ui/core/Grid';
import MuiChip from '@material-ui/core/Chip';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { ReactMultiEmail } from 'react-multi-email';
import 'react-multi-email/style.css';

import styled from 'styled-components/macro';

import EmailBody from '../engine/TextEditorEngine';
import { Context } from '../engine/EmailDialogEngine';
import EmailsInputFromListEngine from '../engine/EmailsInputFromListEngine';

export const EmailBodyWrapper = styled.div`
  margin-top: 0.6em;
`;

const EmailsInput = styled(ReactMultiEmail)`
  && {
    border: 1px solid rgb(196 196 196);
    ${({ readOnly }) => readOnly && 'pointer-events: none;'}
  }

  && > input {
    font-family: montserrat, arial;
    font-size: 16px;
    width: 100% !important;
  }
`;

export const SubjectInput = styled(OutlinedInput)`
  && {
    padding: 0.4em 0.5em;
  }
  input {
    padding: 0.4em 0.1em;
  }
`;

const Chip = styled(MuiChip)`
  && {
    margin-right: 0.4em;
  }
`;

const CcSharedUsersBlock = styled(FormControlLabel)`
  && {
    margin-left: 4.05em;
  }
`;

const ComposeEmailView = props => {
  const {
    initLoader,
    dispatch,
    placeHolders,
    additionalPlaceHolders,
    additionalPlaceHoldersProps,
    noSubject,
    noTo,
    noCC,
    topEndPoint
  } = useContext(Context);

  return (
    <>
      {topEndPoint}
      <Grid
        container
        spacing={2}
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        {/* To input */}
        {noTo ? null : (
          <>
            <Grid item sm={1}>
              To
            </Grid>
            <Grid item sm>
              {props.formId4RequestingInfo ? (
                <EmailsInputFromListEngine
                  formId={props.formId4RequestingInfo}
                  submissionId={props.submissionId}
                  onChange={ids =>
                    dispatch({ type: 'update', payload: { toUserIds: ids } })
                  }
                  defaultRecipient={props.defaultRecipient}
                  defaultToUserIds={props.toUserIds}
                  users={
                    props.recipientOptions.length > 0
                      ? props.recipientOptions
                      : []
                  }
                />
              ) : (
                <EmailsInput
                  readOnly={props.readOnlyEmailsList}
                  emails={props.emails}
                  onChange={emails =>
                    dispatch({ type: 'update', payload: { emails } })
                  }
                  getLabel={(email, i, removeEmail) => (
                    <Chip
                      size="small"
                      label={email}
                      color="primary"
                      // disabled={props.readOnlyEmailsList}
                      onDelete={
                        props.readOnlyEmailsList ? null : () => removeEmail(i)
                      }
                    />
                  )}
                />
              )}
            </Grid>
          </>
        )}
      </Grid>

      {/* CC input */}
      {noCC ? null : (
        <>
          <Grid
            container
            spacing={2}
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item sm={1}>
              CC
            </Grid>
            <Grid item sm>
              <EmailsInput
                emails={props.cc}
                onChange={emails =>
                  dispatch({ type: 'update', payload: { cc: emails } })
                }
                getLabel={(email, i, removeEmail) => (
                  <Chip
                    size="small"
                    label={email}
                    color="primary"
                    onDelete={() => removeEmail(i)}
                  />
                )}
              />
            </Grid>
          </Grid>

          {props.sharedUsers.length > 0 && (
            <CcSharedUsersBlock
              control={
                <Checkbox
                  checked={props.toggleCcSharedUsers}
                  onChange={props.onCcSharedUsersToggeled}
                  name="ccShared"
                  color="primary"
                />
              }
              label="CC shared users"
            />
          )}
        </>
      )}

      {noSubject ? null : (
        <>
          {/* Subject input */}
          <Grid
            container
            spacing={2}
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item sm={1}>
              Subject
            </Grid>
            <Grid item sm>
              <SubjectInput
                value={props.subject}
                fullWidth
                size="small"
                onChange={e =>
                  dispatch({
                    type: 'update',
                    payload: { subject: e.target.value }
                  })
                }
                data-testid='editor-subject'
              />
            </Grid>
          </Grid>
        </>
      )}

      {/* Body input */}
      <EmailBodyWrapper>
        {!initLoader && (
          <EmailBody
            onChange={value =>
              dispatch({ type: 'update', payload: { body: value } })
            }
            fieldsPlaceholders={placeHolders}
            additionalPlaceHolders={additionalPlaceHolders}
            additionalPlaceHoldersProps={additionalPlaceHoldersProps}
            editorText={props.body}
          />
        )}
      </EmailBodyWrapper>
    </>
  );
};

export default ComposeEmailView;
